// components/FeatureSection/FeatureSection.jsx
import React from 'react';
import { FaCode, FaMobileAlt, FaCloud, FaShieldAlt, FaRobot, FaDatabase } from 'react-icons/fa';
import './FeatureSection.css';

const features = [
  {
    id: 'soft',
    icon: FaCode,
    title: 'Software That Fits',
    description: 'Custom-built solutions that fit your workflow. From CRM to ERP, our software grows with your business.',
  },
  {
    id: 'mobile',
    icon: FaMobileAlt,
    title: 'Apps That Connect',
    description: 'Mobile and web applications that are fast, scalable, and human-centered for better user engagement.',
  },
  {
    id: 'cloud',
    icon: FaCloud,
    title: 'Cloud & Infrastructure',
    description: 'Secure, scalable, and accessible cloud solutions with 24×7 DevOps automation.',
  },
  {
    id: 'ai',
    icon: FaRobot,
    title: 'AI That Thinks Ahead',
    description: 'Predict trends, optimize decisions, and automate workflows using AI and ML.',
  },

   
  {
    id: 'security',
    icon: FaShieldAlt,
    title: 'Digital Marketing',
    description: 'SEO, social, and performance marketing designed to get measurable growth.',
  },
  {
    id: 'database',
    icon: FaDatabase,
    title: 'Data Management',
    description: 'Efficient, scalable, and secure data storage solutions for modern businesses.',
  },
];

const FeatureSection = () => {
  return (
    <div className="feature-grid-container">
      {features.map((item, index) => {
        const Icon = item.icon;
        return (
          <div
            className="feature-tile"
            key={item.id}
            style={{ animationDelay: `${index * 0.15}s` }}
          >
            <div className="tile-icon">
              <Icon />
            </div>
            <h3 className="tile-title">{item.title}</h3>
            <p className="tile-description">{item.description}</p>
          </div>
        );
      })}
    </div>
  );
};

export default FeatureSection;
